import { ERenamePreset, ERenameTitle, ERenamedDimension } from './enum';

const renamePresetDimensionMap = {
  [ERenamePreset.PAGE]: ERenamedDimension.edited_page_title,
  [ERenamePreset.SCREEN]: ERenamedDimension.edited_screen_title,
};
const renameTitleDimensionMap = {
  [ERenameTitle.PAGE]: ERenamedDimension.edited_page_title,
  [ERenameTitle.SCREEN]: ERenamedDimension.edited_screen_title,
};
// blocked events which can still be mapped
const blockedCanMapWhiteList = ['conviva_network_request'];

export { renamePresetDimensionMap, renameTitleDimensionMap, blockedCanMapWhiteList };
